import axios from "axios";
import { rootApiUrl } from "../environment/Environment";


export const getAllPAtients = async (clinicId) => {
    return await axios.get(`${rootApiUrl}/api/v0.2/patients/get-all`, { params: { clinicId } });
};

export const addNewPatient = async (patientData) => {
    return await axios.post(`${rootApiUrl}/api/v0.2/patients/patient`, patientData);
};

export const getPatientHistory = async (patientId) => {
    return await axios.get(`${rootApiUrl}/api/v0.2/patients/history`, { params: { patientId: patientId } });
};

export const addPatientHistory = async (patientHistory) => {
    return await axios.post(`${rootApiUrl}/api/v0.2/patients/history`, patientHistory);
};

export const getAllPatientByClinicId = async (payload) => {
    return await axios.get(`${rootApiUrl}/api/v0.2/patients/patient`, { params: { ...payload } });
};

export const getPatientNote = async (payload) => {
    return await axios.get(`${rootApiUrl}/api/v0.2/patients/notes`, { params: { patientId: payload.patientId, typeOfNotes: payload.typeOfNotes } });
};

export const getPatientPastProcedureList = async (patientId) => {
    return await axios.get(`${rootApiUrl}/api/v0.2/cosmetic-treatment/get-patient-past-procedure-list/${patientId}`);
};

export const getPatientById = async (patientId) => {
    return await axios.get(`${rootApiUrl}/api/v0.2/patients/get-patient-by-id/${patientId}`);
};

export const deletePatientById = async (patientId) => {
    return await axios.put(`${rootApiUrl}/api/v0.2/patients/delete`, null, { params: { patientId: patientId } });
};

export const getPatientPurchaseHistory = async (patientId) => {
    // return await axios.get(`${rootApiUrl}/api/v0.2/patients/history`, { params: { patientId: patientId } });
    return await axios.get(`${rootApiUrl}/get-patient-purchase-history`, { params: { patientId: patientId } });
};

export const getPatientCreditList = async (payload) => {
    return await axios.get(`${rootApiUrl}/api/v0.2/patients/credit`, { params: { ...payload } });
};

export const addPatientCredit = async (creditData) => {
    return await axios.post(`${rootApiUrl}/api/v0.2/patients/credit`, creditData);
};

export const getAllPatientImage = async (payload) => {
    return await axios.get(`${rootApiUrl}/api/v0.2/patients/get-all-image`, { params: { ...payload } });
};

export const uploadPatientGeneralImage = async (data) => {
    return await axios.post(`${rootApiUrl}/api/v0.2/patients/upload-general-image`, data)
};

export const uploadPatientGeneralImageFile = async (file) => {
    return await axios.post(`${rootApiUrl}/api/v0.2/patients/upload-general-image-file`, file)
};

export const getPatientCommunication = async (patientId) => {
    return await axios.get(`${rootApiUrl}/api/v0.2/patients/get-communication`, { params: { patientId: patientId } });
};

export const reviewEmailByPatientId = async (patientId) => {
    return await axios.post(`${rootApiUrl}/api/v0.2/patients/send-review-email`, null, { params: { patientId } })
};

export const sendPatientReplyEmailData = async (data) => {
    return await axios.post(`${rootApiUrl}/api/v0.2/patients/send-reply-to-patient-with-attachment`, data) 
};

export const getReceiveMailData = async (email) => {
    return await axios.get(`${rootApiUrl}/api/v0.2/patients/get-email-wise-patient-receive-mail`, { params: { email: email } });
};
export const getSentMailData = async (email) => {
    return await axios.get(`${rootApiUrl}/api/v0.2/patients/get-email-wise-patient-sent-mail`, { params: { email: email } });
};

// export const getBookingReceiveEmailFor = async () => {
//     return await axios.get(`${rootApiUrl}/api/v0.2/patients/get-booking-received-mail`);
// };